import { render, staticRenderFns } from "./CodingTop.vue?vue&type=template&id=3fbbc071&"
import script from "./CodingTop.vue?vue&type=script&lang=js&"
export * from "./CodingTop.vue?vue&type=script&lang=js&"
import style0 from "./CodingTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports